import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Section } from './ui/Section';
export function PainPoints() {
  return <Section bg="section" data-id="element-42">
      <FadeIn data-id="element-43">
        <h2 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-44">
          Si cobrás por tu cuenta… este texto te va a molestar un poco.
        </h2>
      </FadeIn>

      <FadeIn delay={0.1} data-id="element-45">
        <p className="text-lg mb-6" data-id="element-46">
          Porque describe algo que probablemente escondés incluso de vos:
        </p>
        <p className="text-xl font-serif font-bold text-text-primary mb-8" data-id="element-47">
          Cobrás y seguís ahogado.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-48">
        <p className="text-lg mb-6" data-id="element-49">
          No porque seas un desastre. Porque el “orden financiero” que te
          enseñaron está diseñado para gente con sueldo fijo, horarios fijos y
          cerebro descansado.
        </p>
        <p className="text-lg mb-6" data-id="element-50">Vos tenés otra realidad:</p>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-51">
        <ul className="space-y-3 mb-10 pl-6 border-l-2 border-accent-warm/30" data-id="element-52">
          <li className="text-lg text-text-secondary" data-id="element-53">
            Semanas buenas y semanas flojas
          </li>
          <li className="text-lg text-text-secondary" data-id="element-54">
            Cobros que llegan tarde
          </li>
          <li className="text-lg text-text-secondary" data-id="element-55">Gastos que no esperan</li>
          <li className="text-lg text-text-secondary" data-id="element-56">
            Deudas que te comen el mes siguiente
          </li>
          <li className="text-lg text-text-secondary" data-id="element-57">
            Impuestos que aparecen como una cachetada
          </li>
        </ul>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-58">
        <div className="bg-warm-highlight p-6 rounded-lg border border-warm-border mb-10" data-id="element-59">
          <p className="font-serif font-medium mb-4 text-text-primary" data-id="element-60">
            Y encima el paquete emocional:
          </p>
          <div className="grid grid-cols-2 gap-4" data-id="element-61">
            <div className="flex items-center gap-2" data-id="element-62">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-warm" data-id="element-63"></span>
              <span data-id="element-64">Vergüenza</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-65">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-warm" data-id="element-66"></span>
              <span data-id="element-67">Culpa</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-68">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-warm" data-id="element-69"></span>
              <span data-id="element-70">Evitación</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-71">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-warm" data-id="element-72"></span>
              <span data-id="element-73">Cansancio</span>
            </div>
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={0.5} data-id="element-74">
        <p className="text-lg mb-4" data-id="element-75">Entonces pasa lo típico:</p>
        <div className="space-y-4 ml-4 mb-10 relative" data-id="element-76">
          <div className="absolute left-0 top-2 bottom-2 w-px bg-warm-border" data-id="element-77"></div>
          {['Te prometés “este mes me ordeno”', 'Armás una planilla o anotás en un cuaderno', 'Aguantás 7–10 días', 'Te cae una semana mala / un gasto', 'Se rompe todo', 'Volvés al modo incendio', 'Y te decís algo feo: “no sirvo para esto”'].map((item, i) => <div key={i} className="flex items-center gap-4 pl-6 relative" data-id="element-78">
              <span className="absolute left-[-4px] top-2 w-2 h-2 rounded-full bg-warm-border" data-id="element-79"></span>
              <p className="text-text-secondary" data-id="element-80">{item}</p>
            </div>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.6} data-id="element-81">
        <h3 className="text-2xl md:text-3xl font-serif font-bold text-accent-teal leading-tight" data-id="element-82">
          No es falta de voluntad. Es que te falta un sistema que aguante la
          vida real.
        </h3>
      </FadeIn>
    </Section>;
}